import addEventListenerOnce from './addEventListenerOnce';
import * as array from './array';
import * as object from './object';
import * as dom from './dom';
import copyProps from './copyProps';
import KeyCodes from './key-codes';
import lowerFirst from './lowerFirst';
import identity from './identity';
import looseEqual from './loose-equal';
import { mergeData } from 'vue-functional-data-merge';
import memoize from './memoize';
import observeDom from './observe-dom';
import pluckProps from './pluckProps';
import prefixPropName from './prefixPropName';
import { registerComponent, registerComponents, registerDirective, registerDirectives, vueUse } from './plugins';
import stableSort from './stable-sort';
import suffixPropName from './suffixPropName';
import unPrefixPropName from './unPrefixPropName';
import upperFirst from './upperFirst';
import warn from './warn';

export { addEventListenerOnce, array, copyProps, dom, KeyCodes, lowerFirst, identity, looseEqual, mergeData, memoize, object, observeDom, pluckProps, prefixPropName, registerComponent, registerComponents, registerDirective, registerDirectives, stableSort, suffixPropName, upperFirst, unPrefixPropName, vueUse, warn };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/index.js
// module id = 0
// module chunks = 1